module.exports = __webpack_public_path__ + "img/checkmark-square.1edcbc5e.svg";